import { useQuery } from 'react-query';
import { useService } from 'shared/providers';

export function useQueryRepAgencies() {
  const { quoteService } = useService();
  const { data, isLoading, isFetching } = useQuery<string[], Error>(['quote-repAgencies'], () =>
    quoteService.getRepAgencies()
  );

  return { repAgencies: data ?? [], isLoading, isFetching } as const;
}
